import script from "./Perfil.vue?vue&type=script&setup=true&lang=js"
export * from "./Perfil.vue?vue&type=script&setup=true&lang=js"

import "./Perfil.vue?vue&type=style&index=0&id=afcb8b5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afcb8b5e"]])

export default __exports__